<template lang = "pug">
div
  fi-form-field(:label = '$t("registerNumber")' :label-cols = 3)
    .input-group.land-register-input-group
      input.form-control.form-control-sm(
        class         = 'land-register-number-input'
        v-model       = 'immovableData.registerNumber'
        :placeholder = '$t("registerNumberPlaceholder")'
        type          = 'text'
      )
      .input-group-append(v-if = 'landRegisterEnabled')
        button.btn.btn-sm.btn-primary(
          type           = 'button'
          :disabled      = 'landRegisterQuerying || !immovableData.registerNumber'
          @click.prevent = 'queryLandRegister'
        )
          | {{ $t('landRegisterQuery') }}
          i.fa.fa-spinner.fa-pulse.ml-1(v-if = 'landRegisterQuerying')
  fi-form-field(:label = '$t("reportingType")' :label-cols = 3)
    fi-select(
      v-model  = 'immovableData.assetReportingType'
      :options = 'reportingTypes'
      sm
    )
  .loan-collateral-asset-immovable-fields-edit.animated.fadeIn.flex-row-direction
    div.width-50.margin-right-20
      fi-form-field(:label = '$t("type")')
        fi-select(
          v-model.number = 'immovableData.warrantyTypeId'
          :options       = 'optionsFromClassifier("warrantyTypes")'
          sm
        )
      fi-form-field.animated.fadeIn(
        v-if   = 'isShowName'
        :label = '$t("immovableName")'
      )
        input.form-control.form-control-sm(
          v-model = 'immovableData.immovableName'
          type           = 'text'
        )
      fi-form-field(:label = '$t("warrantyCadastralUnitIdentifier")')
        input.form-control.form-control-sm(
          v-model = 'immovableData.warrantyCadastralUnitIdentifier'
          type    = 'text'
        )
      fi-form-field(:label = '$t("country")')
        fi-select(
          v-model.number = 'immovableData.warrantyCountryId'
          :options       = 'optionsFromClassifier("countries")'
          sm
        )
      fi-form-field(:label = '$t("county")')
        fi-select(
          v-model.number = 'immovableData.warrantyCountyId'
          :options       = 'counties'
          sm
        )
      fi-form-field(:label = '$t("city")')
        input.form-control.form-control-sm(
          v-model = 'immovableData.warrantyCity'
          type           = 'text'
        )
      fi-form-field(:label = '$t("address")')
        input.form-control.form-control-sm(
          v-model = 'immovableData.warrantyAddress'
          type           = 'text'
        )
      fi-form-field(:label = '$t("postalСode")')
        input.form-control.form-control-sm(
          v-model = 'immovableData.warrantyPostalCode'
          type           = 'text'
        )
      fi-form-field(:label = '$t("warrantyOwnerName")')
        .flex-row-direction
          fi-customer-select(
            v-model      = 'selectedCustomerModel'
            :placeholder = '$t("existingCustomerPlaceholder")'
            :customers   = 'customerOptions'
          )
          .input-group-append
            button.btn.btn-sm.btn-primary(
              @click.prevent = 'addSelectedUserToOwnerList'
            )
              i.far.fa-plus-square.fa-lg
      div
        span.pr-2.bold.offset-sm-6 - {{ $t('or') }} -
        customer-new-brief(
          v-if    = 'createNewCustomer'
          @cancel = 'createNewCustomer = false'
          @submit = 'onCreateCustomer'
        )
        button.btn.btn-link.px-0(
          v-else
          @click.prevent = 'createNewCustomer = true'
        ) {{ $t('createCustomer') }}
        .flex-column-direction(v-if = 'showOwnerList')
          <table style="width:100%">
            <tr style = 'text-align: center;'>
              <th style = 'width: 50%'></th>
              <th style = 'width: 10%'>{{ $t("primary") }}</th>
              <th style = 'width: 20%'>{{ $t("ownerShip") }}</th>
              <th style = 'width: 10%'></th>
            </tr>
            template(v-for = '(owner, index) in assetOwner')
              <tr>
                <td class = 'bold'> {{ owner.customerName }} </td>
                <td style = 'display: flex;'>
                  input(
                    style   = 'width: 100%; height: 35px;'
                    v-model = 'owner.primaryOwner'
                    type    = 'checkbox'
                    @change = 'selectOwnerPrimary(index)'
                  )
                </td>
                <td>
                  percent-input(
                    v-model = 'owner.ownershipPercentage')
                </td>
                <td style = 'text-align: center;'>
                  i.far.fa-trash-alt.fa-lg.text-danger.cursor-pointer(
                    @click = 'removeOwnerFromOwnerList(index)'
                  )
                </td>
              </tr>
          </table>
      fi-form-field(
        :label = '$t("value")'
        :state = '!state.assetData.value.$error'
      )
        template(#error)
          .error-message(v-if = '!state.assetData.value.required') {{ $t('common:required') }}
        fi-money-input.form-control.form-control-sm(
          v-model.number = 'assetData.value'
          :class         = '{ "is-invalid": state.assetData.value.$error }'
        )
      fi-form-field(
        :label = '$t("valueDate")'
        :state = '!state.assetData.valueDate.$error'
      )
        template(#error)
          .error-message(v-if = '!state.assetData.valueDate.required') {{ $t('common:required') }}
        fi-datepicker(
          v-model = 'assetData.valueDate'
          :class = '{ "is-invalid": state.assetData.valueDate.$error }'
          sm
        )
      fi-form-field(:label = '$t("allocatedValue")')
        fi-money-input.form-control.form-control-sm(
          v-model.number = 'assetData.allocatedValue'
        )
    div.width-50
      fi-form-field(:label = '$t("valueType")')
        fi-select(
          v-model.number = 'immovableData.valueType'
          :options       = 'valueTypes'
          sm
        )
      fi-form-field(:label = '$t("valuationType")')
        fi-select(
          v-model.number = 'immovableData.valuationType'
          :options       = 'valuationTypes'
          sm
        )
      fi-form-field(:label = '$t("locationCode")')
        fi-select(
          v-model.number = 'immovableData.collateralLocationCode'
          :options       = 'locationCodes'
          sm
        )
      fi-form-field(:label = '$t("assetStatus")')
        fi-select(
          v-model.number = 'immovableData.assetStatus'
          :options       = 'assetStatus'
          sm
        )
      //- fi-form-field(:label = '$t("appraisalPartner")')
      //-   fi-customer-select(
      //-     v-model = 'selectedAppraisalPartnerModel'
      //-     flag    = true
      //-   )
      fi-form-field(:label = '$t("assetSoldValue")')
        input.form-control.form-control-sm(
          v-model.number = 'immovableData.assetSoldValue'
          type           = 'text'
        )
      fi-form-field(:label = '$t("soldDate")')
        fi-datepicker(
          v-model = 'immovableData.soldDate'
          sm
        )
      fi-form-field(:label = '$t("warrantyArea")')
        .form-row
          .col
            input.form-control.form-control-sm(
              v-model.number = 'immovableData.warrantyArea'
              type           = 'text'
            )
          .col
            fi-select(
              v-model.number = 'immovableData.areaSizeTypeId'
              :options       = 'optionsFromClassifier("immovableAreaSizeType")'
              required
              sm
            )
      fi-form-field(:label = '$t("appraisalReport")')
        fi-switch.mt-1(
          v-model   = 'assetData.appraisalReport'
          :on-text  = '$t("common:yes")'
          :off-text = '$t("common:no")'
        )
      .animated.fadeIn(v-if = 'assetData.appraisalReport')
        fi-form-field(:label = '$t("appraisalPartnerName")')
          input.form-control.form-control-sm(
            v-model.number = 'assetData.appraisalPartnerName'
            type           = 'text'
          )
        fi-form-field(:label = '$t("appraisalValue")')
          fi-money-input.form-control.form-control-sm(
            v-model.number = 'assetData.appraisalValue'
            type           = 'text'
          )
      fi-form-field(:label = '$t("insuranceMandatory")')
        fi-switch.mt-1(
          v-model   = 'assetData.insuranceMandatory'
          :on-text  = '$t("common:yes")'
          :off-text = '$t("common:no")'
        )
      fi-form-field(:label = '$t("insuranceCompany")')
        input.form-control.form-control-sm(
          v-model.number = 'assetData.insuranceCompany'
          type           = 'text'
        )
      fi-form-field(:label = '$t("insuredUntil")')
        fi-datepicker(
          v-model = 'assetData.insuredUntil'
          sm
        )
  .card.mt-3(v-if = 'landRegisterDetails')
    .card-header.land-register-result-header
      span {{ $t('landRegisterResult') }}
      small.text-muted(v-if = 'landRegisterDetails.inquiryDate')
        | {{ $t('landRegisterInquiryDate') }}: {{ formatInquiryDate(landRegisterDetails.inquiryDate) }}
    .card-body
      .mt-2(v-if = 'landRegisterDetails.properties && landRegisterDetails.properties.length')
        .bold {{ $t('landRegisterProperties') }}
        div(v-for = 'property in landRegisterDetails.properties' :key = 'property.cadastralCode + property.address')
          | {{ property.cadastralCode }} — {{ formatPropertyAddress(property.address) }}<span(v-if = 'property.postalCode')>, {{ property.postalCode }}</span><span(v-if = 'property.area')> — {{ property.area }} m²</span><span(v-if = 'property.intendedUse')> — {{ property.intendedUse }}</span>
      .mt-2(v-if = 'landRegisterDetails.owners && landRegisterDetails.owners.length')
        .bold {{ $t('landRegisterOwners') }}
        div(v-for = 'owner in landRegisterDetails.owners' :key = 'owner.code + owner.name')
          | {{ owner.name }}<span(v-if = 'owner.ownershipShare')> ({{ owner.ownershipShare }})</span>
      .mt-2(v-if = 'landRegisterDetails.encumbrances && landRegisterDetails.encumbrances.length')
        .bold {{ $t('landRegisterEncumbrances') }}
        .land-register-entry(v-for = 'entry in landRegisterDetails.encumbrances' :key = 'entry.entryNumber + entry.description')
          .land-register-entry-summary
            span {{ entry.type }}
            span(v-if = 'entry.beneficiary')  — {{ entry.beneficiary }}
          .land-register-entry-details(v-if = 'entry.description' v-html = 'sanitizeLandRegisterHtml(entry.description)')
      .mt-2(v-if = 'landRegisterDetails.mortgages && landRegisterDetails.mortgages.length')
        .bold {{ $t('landRegisterMortgages') }}
        .land-register-entry(v-for = 'mortgage in landRegisterDetails.mortgages' :key = 'mortgage.rankingOrder + mortgage.description')
          .land-register-entry-summary
            span {{ formatLandRegisterAmount(mortgage.amount) }} EUR
            span(v-if = 'mortgage.mortgagee && !containsHtml(mortgage.mortgagee)')  — {{ mortgage.mortgagee }}
          .land-register-entry-details(v-if = 'mortgage.mortgagee && containsHtml(mortgage.mortgagee)' v-html = 'sanitizeLandRegisterHtml(mortgage.mortgagee)')
          .land-register-entry-details(v-if = 'mortgage.description' v-html = 'sanitizeLandRegisterHtml(mortgage.description)')
      .text-muted.mt-2(v-if = '!hasLandRegisterRestrictions')
        | {{ $t('landRegisterNoRestrictions') }}
  .full-width-fields
    fi-form-field(:label = '$t("assetInfo")' :label-cols = 12)
      fi-rich-text-editor(v-model = 'assetData.assetInfo' compact)
    fi-form-field(:label = '$t("internalComment")' :label-cols = 12)
      fi-rich-text-editor(v-model = 'assetData.comment' compact)
</template>


<script>
import FiDatepicker from '@/components/FiDatepicker'
import FiFormField from '@/components/FiFormField'
import FiMoneyInput from '@/components/FiMoneyInput'
import FiRichTextEditor from '@/components/FiRichTextEditor'
import FiSelect from '@/components/FiSelect'
import FiSwitch from '@/components/FiSwitch'
import FiCustomerSelect from '@/components/FiCustomerSelect'
import PercentInput from '@/components/PercentInput'
import CustomerNewBrief from '@/views/customers/CustomerNewBrief'
import { mapGetters, mapState } from 'vuex'
import api from '@/api'
import sanitizeHtml from 'sanitize-html'

export default {
  name: 'loan-collateral-asset-immovable-fields-edit',

  components: {
    FiRichTextEditor,
    FiMoneyInput,
    FiFormField,
    FiSelect,
    FiDatepicker,
    FiSwitch,
    FiCustomerSelect,
    CustomerNewBrief,
    PercentInput
  },

  props: {
    immovableData: {
      type: Object,
      required: true
    },
    assetData: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    appraisalPartnerData: {
      type: Object,
      default: null
    },
    assetOwner: {
      type: Array,
      default: () => []
    }
  },

  i18nOptions: {},

  data: (vm) => ({
    createNewCustomer: false,
    selectedCustomer: null,
    selectedAppraisalPartner: vm.appraisalPartnerData,
    showOwnerList: false,
    deleting: false,
    ownerList: [],
    assetOwnerData: [],
    selectedRegNumberData: {},
    customerOptions: [],
    landRegisterDetails: null,
    landRegisterQuerying: false,
    landRegisterEnabled: false
  }),

  computed: {
    ...mapState('loans', ['loan']),
    ...mapGetters('classifiers', ['optionsFromClassifier', 'optionsFromCountiesByCountry', 'classifierById', 'classifierList']),
    counties () {
      return this.optionsFromCountiesByCountry(this.immovableData.warrantyCountryId)
    },
    assetStatus () {
      return this.optionsFromClassifier('ASSET_STATUS', true)
    },
    reportingTypes () {
      return this.optionsFromClassifier('TYP_PRTCTN', true)
    },
    valueTypes () {
      return this.optionsFromClassifier('TYP_PRTCTN_VL', true)
    },
    valuationTypes () {
      return this.optionsFromClassifier('PRTCTN_VLTN_APPRCH', true)
    },
    locationCodes () {
      return this.optionsFromClassifier('ISO3166_NUTS_DSJNT', true)
    },
    selectedCustomerModel: {
      get () {
        return this.selectedCustomer
      },
      async set (selected) {
        this.selectedCustomer = selected
      }
    },
    selectedAppraisalPartnerModel: {
      get () {
        return this.selectedAppraisalPartner
      },
      set (selected) {
        if (selected) {
          this.selectedAppraisalPartner = selected
          this.immovableData.appraisalPartnerId = selected.id
        } else {
          this.selectedAppraisalPartner = null
          this.immovableData.appraisalPartnerId = ''
        }
      }
    },
    isShowName () {
      return /land|lot/i.test(this.classifierById('warrantyTypes', this.immovableData.warrantyTypeId).code)
    },
    lengthOwnerList () {
      return this.assetOwner.length
    },
    hasLandRegisterRestrictions () {
      return Boolean(this.landRegisterDetails && (this.landRegisterDetails.encumbrances?.length || this.landRegisterDetails.mortgages?.length))
    }
  },

  watch: {
    lengthOwnerList: {
      handler (value) {
        value ? this.showOwnerList = true : this.showOwnerList = false
      },
      deep: true
    }
  },

  async created () {
    await this.loadLandRegisterStatus()
    this.landRegisterDetails = this.parseLandRegisterDetails(this.immovableData.landRegisterDetails)
    if (this.immovableData.assetsOwners.length) {
      this.assetOwnerData = this.immovableData.assetsOwners
      this.showOwnerList = true
      this.ownerList = this.immovableData.assetsOwners
    }
    if (!this.assetData.value) {
      if (this.appraisalPartnerData) {
        this.selectedAppraisalPartner = this.appraisalPartnerData
      }
    }
  },

  methods: {
    sanitizeLandRegisterHtml (value) {
      return sanitizeHtml(value || '', {
        allowedTags: ['br', 'p', 'strong', 'em', 'u', 'span', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
        allowedAttributes: {
          '*': ['class', 'style']
        },
        nonTextTags: ['style', 'script', 'textarea', 'noscript']
      })
    },
    containsHtml (value) {
      return /<\/?[a-z][\s\S]*>/i.test(value || '')
    },
    formatLandRegisterAmount (value) {
      if (value === null || value === undefined || value === '') return value
      return Number(value).toLocaleString(this.$i18n.locale, { maximumFractionDigits: 2 })
    },
    formatInquiryDate (value) {
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      const pad = number => String(number).padStart(2, '0')
      return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    async loadLandRegisterStatus () {
      try {
        const { data } = await api.isLandRegisterEnabled()
        this.landRegisterEnabled = data === true
      } catch (error) {
        this.landRegisterEnabled = false
      }
    },
    async onCreateCustomer ({ customer }) {
      this.createNewCustomer = false
      this.selectedCustomerModel = customer
    },
    addSelectedUserToOwnerList () {
      if (this.selectedCustomer) {
        this.assetOwner.push({ customerName: this.selectedCustomer.customerName, primaryOwner: false, ownershipPercentage: 0, customerId: this.selectedCustomer.id })
      }
    },
    selectOwnerPrimary (index) {
      if (this.assetOwner[index].primary) {
        this.assetOwner.forEach((el, id) => {
          if (index !== id) {
            el.primary = false
          }
        })
      }
    },
    removeOwnerFromOwnerList (index) {
      this.assetOwner.splice(index, 1)
    },
    async queryLandRegister () {
      const registryPartNumber = this.immovableData.registerNumber?.trim()
      if (!registryPartNumber) return

      this.landRegisterQuerying = true
      try {
        const { data } = await api.getLandRegisterDetails({ registryPartNumber })

        // Only populate the form after a non-empty result has been received.
        // A failed/empty query must not modify any form field.
        if (!data || !data.registryPartNumber || (!data.properties?.length && !data.owners?.length)) {
          this.$toasted.error(this.$t('landRegisterRecordNotFound', { registryPartNumber }))
          return
        }

        this.landRegisterDetails = data
        this.immovableData.landRegisterDetails = JSON.stringify(data)
        this.immovableData.registerNumber = data.registryPartNumber || this.immovableData.registerNumber
        const estoniaId = this.findClassifierIdByCode('countries', ['EE', 'ESTONIA', 'EESTI'])
        if (estoniaId !== null) {
          this.immovableData.warrantyCountryId = estoniaId
        }
        const countyId = this.findOptionValue(this.counties, [data.county])
        if (countyId !== null) {
          this.immovableData.warrantyCountyId = countyId
        }
        if (data.municipality) {
          this.immovableData.warrantyCity = data.municipality
        }
        const firstProperty = data.properties?.[0]
        const intendedUse = firstProperty?.intendedUse
        const warrantyTypeId = this.resolveWarrantyTypeId(intendedUse, data.propertyType)
        this.immovableData.warrantyTypeId = warrantyTypeId
        this.immovableData.assetReportingType = this.findOptionValue(this.reportingTypes, [this.resolveReportingTypeCode(warrantyTypeId, intendedUse, data.propertyType)])
        this.immovableData.valueType = this.findOptionValue(this.valueTypes, ['3'])
        const assetStatus = this.resolveAssetStatus(data.state)
        if (assetStatus !== null) {
          this.immovableData.assetStatus = assetStatus
        }
        // The classifier is translated as "m²" in the UI, so matching the
        // displayed text with "m2" is not reliable. Resolve the classifier
        // by its stable M2 code instead.
        const areaSizeTypeId = this.findClassifierIdByCode('immovableAreaSizeType', ['M2'])
        if (areaSizeTypeId !== null) {
          this.immovableData.areaSizeTypeId = areaSizeTypeId
        }
        if (firstProperty) {
          const addressParts = this.splitAddressAndPostalCode(firstProperty.address, firstProperty.postalCode)
          this.immovableData.warrantyCadastralUnitIdentifier = firstProperty.cadastralCode || this.immovableData.warrantyCadastralUnitIdentifier
          this.immovableData.warrantyAddress = addressParts.address || this.immovableData.warrantyAddress
          this.immovableData.warrantyArea = firstProperty.area || this.immovableData.warrantyArea
          const postalCode = addressParts.postalCode
          if (postalCode) {
            this.immovableData.warrantyPostalCode = postalCode
          }
        }
        if (data.owners?.length) {
          this.immovableData.warrantyOwnerName = data.owners.map(owner => `${owner.name}${owner.ownershipShare ? ` (${owner.ownershipShare})` : ''}`).join(', ')
        }
        this.assetData.assetInfo = this.$t('landRegisterImportedInfo')
        if (this.loan) {
          this.assetData.creditContractInfos = [{ contractNumber: this.loan.agreementNumber, customerName: this.loan.customerBorrower.customerName }]
        }
      } finally {
        this.landRegisterQuerying = false
      }
    },
    findOptionValue (options, values) {
      const normalizedValues = values.filter(Boolean).map(value => value.toString().trim().toLowerCase())
      const option = (options || []).find(item => {
        const candidates = [item.text, item.label, item.human, item.code, item.value]
          .filter(Boolean)
          .map(value => value.toString().trim().toLowerCase())
        return candidates.some(candidate => normalizedValues.some(value => candidate === value || candidate.includes(value) || value.includes(candidate)))
      })
      return option ? (option.value ?? option.id ?? null) : null
    },
    findClassifierIdByCode (classifier, values) {
      const normalizedValues = values.map(value => this.normalizeText(value))
      const classifiers = Object.values(this.classifierList(classifier) || {})
      const match = classifiers.find(item => {
        const candidates = [item.code, item.name, item.human]
          .filter(Boolean)
          .map(value => this.normalizeText(value))
        return candidates.some(candidate => normalizedValues.includes(candidate))
      })
      return match ? (match.id ?? match.countryDto?.id ?? null) : null
    },
    resolveWarrantyTypeId (intendedUse, propertyType) {
      const normalizedPropertyType = this.normalizeText(propertyType)
      const normalizedIntendedUse = this.normalizeText(intendedUse)
      if (normalizedPropertyType.includes('korter') || normalizedPropertyType.includes('apartment') || normalizedIntendedUse.includes('korteriomand')) {
        return this.findOptionValue(this.optionsFromClassifier('warrantyTypes'), ['1', 'apartment'])
      }
      if (normalizedIntendedUse.includes('elamumaa') || normalizedIntendedUse.includes('uksikelamu')) {
        return this.findOptionValue(this.optionsFromClassifier('warrantyTypes'), ['2', 'house'])
      }
      if (normalizedIntendedUse.includes('arimaa') || normalizedIntendedUse.includes('tootmismaa') || normalizedIntendedUse.includes('uhiskondlike')) {
        return this.findOptionValue(this.optionsFromClassifier('warrantyTypes'), ['3', 'build up area'])
      }
      return this.findOptionValue(this.optionsFromClassifier('warrantyTypes'), ['4', 'lot'])
    },
    resolveReportingTypeCode (warrantyTypeId, intendedUse, propertyType) {
      const warrantyType = this.classifierById('warrantyTypes', warrantyTypeId) || {}
      const warrantyTypeCode = this.normalizeText(warrantyType.code || warrantyType.name || warrantyType.human)
      const normalizedPropertyType = this.normalizeText(propertyType)
      const normalizedIntendedUse = this.normalizeText(intendedUse)
      if (warrantyTypeCode.includes('apartment') || warrantyTypeCode.includes('flat') || normalizedPropertyType.includes('korter')) return '8_B'
      if (warrantyTypeCode.includes('house') || warrantyTypeCode.includes('detached') || warrantyTypeCode.includes('single') || normalizedIntendedUse.includes('uksikelamu')) return '8_A'
      if (warrantyTypeCode.includes('lot') || warrantyTypeCode.includes('land') || normalizedIntendedUse.includes('maatulundusmaa') || normalizedIntendedUse.includes('transpordimaa') || normalizedIntendedUse.includes('riigikaitsemaa') || normalizedIntendedUse.includes('sihtotstarbeta')) return '8_E'
      if (warrantyTypeCode.includes('build') || warrantyTypeCode.includes('commercial') || normalizedIntendedUse.includes('arimaa') || normalizedIntendedUse.includes('tootmismaa')) return '10_F'
      if (normalizedIntendedUse.includes('elamumaa')) return '8_A'
      return '8_C'
    },
    resolveCollateralLocationCode (county, municipality, address) {
      const location = [county, municipality, address]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      if (location.includes('ida-viru') || location.includes('narva') || location.includes('sillamae') || location.includes('kohtla')) return 'EE00A'
      if (location.includes('jarva') || location.includes('laane-viru') || location.includes('rapla')) return 'EE009'
      if (location.includes('hiiu') || location.includes('laane maakond') || location.includes('parnu') || location.includes('saare')) return 'EE004'
      if (location.includes('jogeva') || location.includes('polva') || location.includes('tartu') || location.includes('valga') || location.includes('viljandi') || location.includes('voru')) return 'EE008'
      return 'EE001'
    },
    resolveAssetStatus (state) {
      const normalizedState = this.normalizeText(state)
      if (!normalizedState) return null
      if (normalizedState.includes('kehtiv') || normalizedState.includes('aktiivne') || normalizedState.includes('active')) {
        return this.findOptionValue(this.assetStatus, ['ACTIVE', 'active', 'kehtiv'])
      }
      if (normalizedState.includes('kehtetu') || normalizedState.includes('suletud') || normalizedState.includes('closed') || normalizedState.includes('inactive')) {
        return this.findOptionValue(this.assetStatus, ['INACTIVE', 'inactive', 'closed', 'kehtetu', 'suletud'])
      }
      return null
    },
    extractPostalCode (address) {
      return address?.match(/\b\d{5}\b/)?.[0] || null
    },
    formatPropertyAddress (address) {
      return (address || '').replace(/,\s*$/, '')
    },
    parseLandRegisterDetails (value) {
      if (!value) return null
      if (typeof value === 'object') return value
      try {
        return JSON.parse(value)
      } catch (error) {
        return null
      }
    },
    splitAddressAndPostalCode (address, postalCode) {
      const sourceAddress = (address || '').trim()
      const embeddedPostalCode = this.extractPostalCode(sourceAddress)
      const extractedPostalCode = postalCode || embeddedPostalCode
      const addressWithoutPostalCode = sourceAddress
        .replace(/\b\d{5}\b\s*/, '')
        .replace(/,\s*,/g, ',')
        .replace(/,\s*$/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim()
      return {
        address: addressWithoutPostalCode,
        postalCode: extractedPostalCode
      }
    },
    normalizeText (value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-row-direction {
  display: flex;
}
.flex-column-direction {
  display: flex; flex-direction: column;
}
.bold {
  font-weight: bold;
}
.cursor-pointer {
  cursor: pointer;
}
.justify-content-space-evenly {
  justify-content: space-evenly;
}
.width-50 {
  width: 50%;
}
.margin-right-20 {
  margin-right: 20px
}
.land-register-entry {
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  background: #fafbfc;
}
.land-register-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.land-register-entry-summary {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: 500;
  line-height: 1.5;
}
.land-register-entry-details {
  margin-top: 8px;
  padding: 8px 10px;
  overflow-x: auto;
  border-left: 3px solid #6c8ebf;
  background: #fff;
  font-size: .92rem;
  line-height: 1.45;
}
.land-register-entry-details ::v-deep table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}
.land-register-entry-details ::v-deep td,
.land-register-entry-details ::v-deep th {
  padding: 6px 8px;
  border: 1px solid #e1e6eb;
  vertical-align: top;
  text-align: left;
}
.land-register-input-group {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 620px;
}
.land-register-number-input {
  flex: 0 1 480px;
  min-width: 0;
  margin-right: 10px;
}
.land-register-input-group .input-group-append {
  display: flex;
  flex: 0 0 auto;
  margin-left: 0;
}
.full-width-fields {
  width: 100%;
}
.full-width-fields ::v-deep .fi-form-field-label,
.full-width-fields ::v-deep .fi-form-field-value {
  flex: 0 0 100%;
  max-width: 100%;
}
.full-width-fields ::v-deep .fi-form-field-label {
  padding-bottom: 6px;
}
.full-width-fields ::v-deep .fi-rich-text-editor {
  width: 100%;
}
</style>

<i18n>
en:
  registerNumberPlaceholder:          "Enter registration number"
  landRegisterQuery:                 "Land Register query"
  landRegisterResult:                "Land Register result"
  landRegisterInquiryDate:            "Inquiry date"
  landRegisterState:                 "Status"
  landRegisterProperties:             "Properties"
  landRegisterOwners:                "Owners"
  landRegisterEncumbrances:           "Encumbrances and restrictions"
  landRegisterMortgages:             "Mortgages"
  landRegisterNoRestrictions:        "No mortgages or restrictions returned"
  landRegisterImportedInfo:          "Fields populated from the Estonian Land Register"
  landRegisterRecordNotFound:        "No Land Register record was found for registration number {registryPartNumber}"
  existingCustomerPlaceholder:       "Select customer"
  existingRegisterNumberPlaceholder: "Select number"
  registerNumber:                    "Register number"
  type:                              "Immovable type"
  immovableName:                     "Immovable name"
  country:                           "Country"
  county:                            "County"
  createCustomer:                    "Create customer"
  city:                              "City"
  address:                           "Address"
  value:                             "Value"
  valueDate:                         "Value date"
  allocatedValue:        "Allocated value"
  appraisalReport:                   "Appraisal report"
  appraisalPartnerName:              "Appraisal partner"
  appraisalValue:                    "Appraisal value"
  insuranceMandatory:                "Insurance mandatory"
  insuranceCompany:                  "Insurance company"
  insuredUntil:                      "Insured until"
  assetInfo:                         "Asset info"
  internalComment:                   "Internal comments"
  warrantyCadastralUnitIdentifier:   "Cadastral unit identifier"
  warrantyArea:                      "Area"
  warrantyOwnerName:                 "Owner name"
  primary:                           "Primary"
  ownerShip:                         "Ownership"
  postalСode:                        "Postal code"
  soldDate:                          "Sold date"
  assetSoldValue:                    "Asset sold value"
  appraisalPartner:                  "Appraisal partner"
  reportingType:                     "Reporting type"
  valueType:                         "Value type"
  valuationType:                     "Valuation type"
  locationCode:                      "Location code"
  assetStatus:                       "Asset status"
et:
  registerNumberPlaceholder:          "Sisesta registriosa number"
  landRegisterQuery:                 "Kinnistusraamatu päring"
  landRegisterResult:                "Kinnistusraamatu tulemus"
  landRegisterInquiryDate:            "Päringu kuupäev"
  landRegisterState:                 "Staatus"
  landRegisterProperties:             "Kinnistud"
  landRegisterOwners:                "Omanikud"
  landRegisterEncumbrances:           "Koormatised ja kitsendused"
  landRegisterMortgages:             "Hüpoteegid"
  landRegisterNoRestrictions:        "Hüpoteeke ega kitsendusi ei tagastatud"
  landRegisterImportedInfo:          "Väljad täideti Eesti kinnistusraamatu andmetega"
  landRegisterRecordNotFound:        "Registriosa numbriga {registryPartNumber} seotud kinnistusraamatu kirjet ei leitud"
  existingCustomerPlaceholder:       "Select customer"
  existingRegisterNumberPlaceholder: "Select number"
  registerNumber:                    "Register number"
  type:                              "Immovable type"
  immovableName:                     "Immovable name"
  country:                           "Country"
  county:                            "County"
  createCustomer:                    "Create customer"
  city:                              "City"
  address:                           "Address"
  value:                             "Value"
  valueDate:                         "Value date"
  allocatedValue:        "Allocated value"
  appraisalReport:                   "Appraisal report"
  appraisalPartnerName:              "Appraisal partner"
  appraisalValue:                    "Appraisal value"
  insuranceMandatory:                "Insurance mandatory"
  insuranceCompany:                  "Insurance company"
  insuredUntil:                      "Insured until"
  assetInfo:                         "Asset info"
  internalComment:                   "Internal comments"
  warrantyCadastralUnitIdentifier:   "Cadastral unit identifier"
  warrantyArea:                      "Area"
  warrantyOwnerName:                 "Owner name"
  primary:                           "Primary"
  ownerShip:                         "Ownership"
  postalСode:                        "Postal code"
  soldDate:                          "Sold date"
  assetSoldValue:                    "Asset sold value"
  appraisalPartner:                  "Appraisal partner"
  reportingType:                     "Reporting type"
  valueType:                         "Value type"
  valuationType:                     "Valuation type"
  locationCode:                      "Location code"
  assetStatus:                       "Asset status"
ru:
  registerNumberPlaceholder:          "Введите регистрационный номер"
  landRegisterQuery:                 "Запрос в земельный регистр"
  landRegisterResult:                "Результат запроса"
  landRegisterInquiryDate:            "Дата запроса"
  landRegisterState:                 "Статус"
  landRegisterProperties:             "Объекты недвижимости"
  landRegisterOwners:                "Собственники"
  landRegisterEncumbrances:           "Обременения и ограничения"
  landRegisterMortgages:             "Ипотеки"
  landRegisterNoRestrictions:        "Ипотеки и ограничения не найдены"
  landRegisterImportedInfo:          "Поля заполнены по данным земельного регистра Эстонии"
  landRegisterRecordNotFound:        "Запись земельного регистра с регистрационным номером {registryPartNumber} не найдена"
  existingCustomerPlaceholder:       "Select customer"
  existingRegisterNumberPlaceholder: "Select number"
  registerNumber:                    "Register number"
  type:                              "Immovable type"
  immovableName:                     "Immovable name"
  country:                           "Country"
  county:                            "County"
  createCustomer:                    "Create customer"
  city:                              "City"
  address:                           "Address"
  value:                             "Value"
  valueDate:                         "Value date"
  allocatedValue:        "Allocated value"
  appraisalReport:                   "Appraisal report"
  appraisalPartnerName:              "Appraisal partner"
  appraisalValue:                    "Appraisal value"
  insuranceMandatory:                "Insurance mandatory"
  insuranceCompany:                  "Insurance company"
  insuredUntil:                      "Insured until"
  assetInfo:                         "Asset info"
  internalComment:                   "Internal comments"
  warrantyCadastralUnitIdentifier:   "Cadastral unit identifier"
  warrantyArea:                      "Area"
  warrantyOwnerName:                 "Owner name"
  primary:                           "Primary"
  ownerShip:                         "Ownership"
  postalСode:                        "Postal code"
  soldDate:                          "Sold date"
  assetSoldValue:                    "Asset sold value"
  appraisalPartner:                  "Appraisal partner"
  reportingType:                     "Reporting type"
  valueType:                         "Value type"
  valuationType:                     "Valuation type"
  locationCode:                      "Location code"
  assetStatus:                       "Asset status"
</i18n>
